import React from 'react';

// Detects a URL-looking token embedded in a larger string. Accepts bare
// domains starting with www. and any http(s) link. Keep the regex narrow —
// this renders arbitrary record fields and shouldn't turn stray text into
// links.
export const URL_TOKEN_REGEX = /\b((?:https?:\/\/|www\.)[^\s<>"'`]+)/gi;

// Splits `value` on URL-looking tokens and wraps each one in a real <a> so
// record fields that happen to contain (or be) a URL — e.g. "Regulation
// URL", "Source URL", a remarks field with a citation link — render as
// clickable links instead of plain text, without disturbing non-URL fields.
export const renderFieldWithLinks = (value: string): React.ReactNode => {
  if (!value) return value;
  const parts: React.ReactNode[] = [];
  let lastIndex = 0;
  let key = 0;
  const text = value;
  for (const match of text.matchAll(URL_TOKEN_REGEX)) {
    const url = match[0];
    const start = match.index ?? 0;
    if (start > lastIndex) {
      parts.push(text.slice(lastIndex, start));
    }
    // Strip trailing punctuation that's almost certainly a sentence
    // terminator rather than part of the URL.
    let cleaned = url;
    let trailing = '';
    while (
      cleaned.length > 0 &&
      '.,);:!?'.includes(cleaned[cleaned.length - 1])
    ) {
      trailing = cleaned[cleaned.length - 1] + trailing;
      cleaned = cleaned.slice(0, -1);
    }
    const href = cleaned.startsWith('http') ? cleaned : `https://${cleaned}`;
    parts.push(
      <a
        key={`url-${key++}`}
        href={href}
        target='_blank'
        rel='noopener noreferrer'
        className='link'
      >
        {cleaned}
      </a>,
    );
    if (trailing) parts.push(trailing);
    lastIndex = start + url.length;
  }
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }
  return parts.length > 0 ? parts : value;
};
